import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlGridTagNames } from './grid.props';

@customElement(AtlGridTagNames.GridThreeCol)
export class AtlGridThreeCol extends LitElement {
   static styles = [...getGlobalStyleSheets()];

   protected override createRenderRoot() {
      return this;
   }

   override updated() {
      this.classList.value = `col-md-4`;
   }
}
